<template>
  <div class="page-effect">
    <div class="container-fluid border-bottom p-0 ss-reg-top">
      <div
        class="
          d-md-flex
          justify-content-end
          page-option-sticky
          sticky-without-menu
        "
      >
        <!-- <a
          href="#"
          class="pt-3 left-effect2"
          data-toggle="modal"
          data-target="#welcomemailModalCenter"
          @click="
            $refs.reminderAnnounceMailPopup.getMailTemplate('ReminderMail')
          "
        >
          <v-icon color="#5f6368" size="18px" class="mr-1"
            >mdi-email-outline</v-icon
          >
          Send Mail</a
        > -->

        <a
          id="v-step-com"
          href="#"
          class="pt-3 left-effect2"
          @click="advanceSettingsDialog()"
          ><v-icon color="#5f6368" size="18px" class="mr-1"
            >mdi-cog-outline</v-icon
          >
          Advanced Settings</a
        >

        <!-- <a
          href="#"
          class="pt-3 left-effect2"
          data-toggle="modal"
          data-target="#CheckoutformypeModal"
          @click="openBulkUploadPopup()"
          ><v-icon color="#5f6368" size="18px" class="mr-1"
            >mdi-tray-arrow-up</v-icon
          >
          Bulk Import</a
        > -->

        <v-btn
          class="my-2 mr-4 save-standard"
          outlined
          color="#2376e5"
          @click="openRTPopup()"
          ><v-icon id="v-step-0" class="mr-1" color="#2376e5" size="20px"
            >mdi-plus</v-icon
          >
          Add New Round Table</v-btn
        >
      </div>

      <div>
        <!-- @onUpdate="onUpdate" -->
        <RoundtableList
          ref="roundtableList"
          :key="rtListKey"
          :isAdminComponent="isAdminComponent"
          @OpenAddRTPopup="OpenAddRTPopup"
          @changeTableStatus="changeTableStatus"
          @deleteTable="deleteTable"
        >
        </RoundtableList>
      </div>
    </div>

    <v-dialog
      v-model="rtAddEditDialog"
      transition="dialog-top-transition"
      max-width="950"
      scrollable
    >
      <template>
        <v-card class="invite-mod ss-cns-body-wrap">
          <div style="position: absolute; right: 10px; top: 15px">
            <v-icon
              style="z-index: 2"
              size="32"
              @click="rtAddEditDialog = false"
              >mdi-close</v-icon
            >
          </div>
          <v-card-title
            ><h5 class="pb-4">Create a New Roundtable</h5>
          </v-card-title>
          <v-card-text>
            <div class="invite-user-head">
              <div
                class="d-flex justify-content-center align-items-center mt-3"
              >
                <RTAddEdit
                  ref="rtAddEditPopUp"
                  :key="rtAddEditKey"
                  :uid="uid"
                  :clientId="clientId"
                  :eventId="eventId"
                  :isAdminComponent="isAdminComponent"
                  :event_collectionName="event_collectionName"
                  :data_local="RT"
                  @OnAddRTSuccess="OnAddRTSuccess"
                  @OnUpdateRTSuccess="OnUpdateRTSuccess"
                ></RTAddEdit>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </template>
    </v-dialog>


    <v-dialog v-model="advanceDialog" width="1000" scrollable>
      

      <v-card>
        <v-card-title class="lighten-5" elevation="4">
          <div class="text-h5 d-flex justify-content-between align-items-center w-100">
            Advance Settings
            <v-btn icon @click="advanceDialog = false"><v-icon color="#333" size="25px">mdi-close</v-icon></v-btn>
          </div>
        </v-card-title>
        <v-divider class="m-0 px-0 pt-0 pb-3"></v-divider>

        <v-card-text class="scroll-wrap" style="height:100%; overflow-y:auto;">
          <RTAdvancesettings></RTAdvancesettings>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      max-width="600"
      scrollable
      v-model="rtAddEditSuccess"
      persistent
      content-class="modal-content"
      transition="scroll-x-reverse-transition"
      style=""
    >
      <!-- <v-card class="modal fade ss-success-modal"> -->

      <v-card-text>
        <div class="modal-content">
          <div class="modal-body text-center">
            <img src="../assets/Images/reg-ico/success.png" alt="e2m" />
            <h2 class="my-5">
              The new round table has been created successfully!
            </h2>
            <div class="ss-cns-foo-btn final-button">
              <v-btn
                outlined
                large
                color="#1a73e8"
                class="mr-2"
                @click="$router.push('/overview')"
                ><v-icon color="#1a73e8" size="20px" class="mr-4"
                  >mdi-arrow-left</v-icon
                >
                Back to overview</v-btn
              >
              <v-btn
                large
                color="#1a73e8"
                dark
                class="px-4"
                @click="CloseSuccess"
              >
                Great
              </v-btn>
            </div>
          </div>
        </div>
      </v-card-text>
      <!-- </v-card> -->
    </v-dialog>

    <!-- <span id="v-step-end" style="display: none"></span>
    <div class="custom-v-tour">
      <v-tour
        name="adminAttendeeListTour"
        :steps="steps"
        :options="tourOptions"
        :callbacks="tourCallbacks"
      ></v-tour>
    </div> -->
  </div>
</template>
<script>
import axios from "axios";
import APIs from "@/components/APIInit";
//import router from "../router";
// import jQuery from "jquery";
// let $ = jQuery;
import db from "../components/firebaseInit";

import RoundtableList from "@/views/RoundtableList-v2.vue";
import RTAddEdit from "@/components/RoundTableAddEdit.vue";
import RTAdvancesettings from "@/components/RoundTableAdminAdvanceSettings.vue";

var vm;
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
//import store from "../store";
import VueTour from "vue-tour";

require("vue-tour/dist/vue-tour.css");
// import axios from "axios";
import { bus } from "@/main";
Vue.use(VueMoment, {
  moment,
});
Vue.use(VueTour);

export default {
  components: {
    RoundtableList,
    RTAddEdit,
    RTAdvancesettings,
  },
  data() {
    return {
      rtAddEditSuccess: false,
      advanceDialog:false,
      tourOptions: {
        labels: {
          buttonSkip: "Skip",
          buttonPrevious: "Previous",
          buttonNext: "Next",
          buttonStop: "Finish",
        },
      },
      tourCallbacks: {
        onNextStep: this.onTourFinish,
      },
      steps: [
        {
          target: "#v-step-0", // We're using document.querySelector() under the hood
          header: {
            title: "Add Round Table:",
          },
          content: `Create a new round table`,
          params: {
            placement: "bottom",
            positionFixed: true,
          },
        },

        {
          target: "#v-step-end",
          header: {
            title: "View Round Table:",
          },
          content: "Review Round Tables and edit them",
          params: {
            placement: "bottom",
            positionFixed: true,
          },
        },
        // {
        //   target: "#v-step-2",
        //   header: {
        //     title: "Advanced Settings:",
        //   },
        //   content: "Advanced settings for nerds! :)",
        //   params: {
        //     placement: "bottom",
        //     positionFixed: true,
        //   },
        // },
      ],
      uid: "",
      clientId: "",
      eventId: "",
      event_collectionName: "",
      isAdminComponent: true,
      rtListKey: 0,
      rtAddEditKey: 0,
      rtAddEditDialog: false,
      // BannerURL: "",
      // mobileBanner: "",
      // desktopBanner: "",
      Attendee: {},
      drawer: null,

      RT: {
        TableId: "",
        TableName: "",
        Topic: null,
        Host: null,
        CoHost: null,
        StreamingClient: "Web",
        approval_type: 0,
        CustomLink: "",
        PreAssigned: false,
        MapTo: { IsMapped: false, Type: 0, Entity: {} },
        IsPublished: true,
        MappedAttendees: [],
        Capacity: 2,
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    vm = this;
    //vm.initScreen();
    // $(window).resize(function () {
    //   vm.initScreen();
    // });
  },
  mounted() {
    vm.uid = vm.getSessionUserId();
    vm.clientId = vm.getClientId();
    vm.eventId = vm.getEventId();
    vm.event_collectionName = vm.getEventCollectionName();

    if (vm.isAdminComponent) {
      // setTimeout(() => {
      //   if (
      //     !vm.$store.getters.getAdminTour ||
      //     !vm.$store.getters.getAdminTour.includes("Attendee")
      //   ) {
      //     if (vm.$store.getters.adminTourSeen) {
      //       store.commit(
      //         "setAdminTour",
      //         vm.$store.getters.adminTourSeen + ",Attendee"
      //       );
      //     } else {
      //       store.commit("setAdminTour", "Attendee");
      //     }
      //     vm.$tours["adminAttendeeListTour"].start();
      //   }
      // }, 2000);
    }

    // bus.$on("complete-roundtable-tour", (flag) => {
    //   if (flag) {
    //     vm.steps.pop();
    //     vm.steps.splice(1, 0, {
    //       target: "#v-step-com",
    //       header: { title: "Advanced Settings:" },
    //       offset: -200,
    //       params: { placement: "bottom", positionFixed: true },
    //       content: "Advanced settings for nerds! :)",
    //     });
    //     if (vm.isAdminComponent) {
    //       setTimeout(() => {
    //         vm.$tours["adminAttendeeListTour"].start();
    //       }, 1000);
    //     }
    //   }
    // });

    // if (vm.$route.hash == "#create") {
    //   vm.openRTPopup();
    // }
  },
  methods: {
    // onTourFinish() {
    //   vm.steps.pop();
    //   bus.$emit("start-roundtable-tour", true);
    // },
    advanceSettingsDialog(){
      vm.advanceDialog = true;
    },
    openRTPopup() {
      vm.OpenAddRTPopup();
    },
    async OpenAddRTPopup(id) {
      vm.RT = null;
      var result = await vm.fetchRoundTable(id);
      debugger;
      if (result.status == 200) {
        vm.RT = result.data;
      }
      vm.rtAddEditDialog = true;
      vm.rtAddEditKey += 1;
      // this.$nextTick(() => {
      //   $("#rtAddEdit").modal("show");
      // });
    },
    CloseAddAttendeePopup() {
      vm.rtAddEditKey += 1;
      vm.rtAddEditDialog = false;
      //$("#rtAddEdit").modal("hide");
    },
    OnAddAttendeeSuccess() {
      vm.CloseAddAttendeePopup();
      vm.OpenSuccess();
    },
    OnUpdateAttendeeSuccess() {
      vm.CloseAddAttendeePopup();
      vm.CloseSuccess();
      vm.showSnackbar("Attendee Updated Succesfully", "success", "top");
    },
    OpenSuccess() {
      //$("#rtAddEditSuccess").modal("show");
      vm.rtAddEditSuccess = true;
    },
    CloseSuccess() {
      vm.rtAddEditSuccess = false;
      //$("#rtAddEditSuccess").modal("hide");
      vm.rtListKey += 1;
    },
    updateAttendeeData(field) {
      bus.$emit("toggleLoader", true);
      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.clientId,
          eventId: vm.eventId,
        },
        data: field,
      };
      axios
        .post(APIs.UpdateSingleAttendee, requestData, { headers: headers })
        .then(function (res) {
          bus.$emit("toggleLoader", false);
          if (res.status == 200) {
            vm.showSnackbar("Attendee updated successfully.", "success", "top");
          } else {
            vm.showSnackbar("Data not updated!", "error", "top");
          }
        })
        .catch(function () {
          bus.$emit("toggleLoader", false);
          vm.showSnackbar("Something went wrong", "error", "top");
        });
    },

    OnAddRTSuccess() {
      vm.rtAddEditDialog = false;
      vm.rtListKey++;
    },
    OnUpdateRTSuccess() {
      vm.rtAddEditDialog = false;
      vm.rtListKey++;
    },

    fetchRoundTable(id) {
      return new Promise((resolve, reject) => {
        if (!id) {
          // let RTTObj = {
          //     TopicName: 'General',
          //     TableCapacity: '12'
          // }
          //context.dispatch('addRoundtableTopic', RTTObj).then(function(rtt) {

          resolve({
            status: 200,
            data: {
              TableId: "",
              TableName: "",
              Topic: null,
              Host: null,
              CoHost: null,
              StreamingClient: "Web",
              approval_type: 0,
              CustomLink: "",
              PreAssigned: false,
              MapTo: { IsMapped: false, Type: "Exhibitor", Entity: {} },
              IsPublished: true,
              MappedAttendees: [],
              Capacity: 12,
              SpectatorEnabled: true,
              Occupied: 0,
              CreatedByID: 0,
              CreatedByName: "",
              // Topic: {
              //     TopicId: rtt.TopicObj.TopicId,
              //     TopicName: rtt.TopicObj.TopicName,
              //     TopicDisplayName: (rtt.TopicObj.TopicName + " (" + rtt.TopicObj.TableCapacity + ")"),
              //     TopicTableCapacity: rtt.TopicObj.TableCapacity
              // },
            },
          });
          //});
        } else {
          let docObj = new Object();
          db.collection(vm.event_collectionName)
            .doc("RoundTableList")
            .collection("RoundTables")
            .doc(`${id}`)
            .get()
            .then(function (doc) {
              docObj = doc.data();
              docObj.TableType = doc.data().PreAssigned
                ? "Pre_assigned"
                : "Open";
              docObj.Host = Array.isArray(doc.data().Host)
                ? doc.data().Host[0]
                : null;
              docObj.CoHost = doc.data().CoHost ? doc.data().CoHost : null;
              docObj.StreamingClient = doc.data().StreamingClient
                ? doc.data().StreamingClient
                : "Web";
              docObj.approval_type =
                doc.data().approval_type != undefined
                  ? doc.data().approval_type
                  : 0;
              docObj.CustomLink = doc.data().CustomLink
                ? doc.data().CustomLink
                : null;
              //docObj.Spectate = doc.data().SpectatorEnabled
              docObj.Spectate = false;
              if (docObj.MapTo == undefined) {
                docObj.MapTo = {
                  IsMapped: false,
                  Type: "Exhibitor",
                  Entity: {},
                };
              } else {
                if (docObj.MapTo.IsMapped == undefined) {
                  docObj.MapTo = {
                    IsMapped: false,
                    Type: "Exhibitor",
                    Entity: {},
                  };
                }
                docObj.MapToOld = docObj.MapTo;
              }
              if (doc.data().Topic.TopicTableCapacity) {
                docObj.Topic = {
                  TopicId: doc.data().Topic.TopicId,
                  TopicName: doc.data().Topic.TopicName,
                  TopicDisplayName: doc.data().Topic.TopicDisplayName,
                  TopicTableCapacity: doc.data().Topic.TopicTableCapacity,
                };
              } else docObj.Topic = null;
              //console.log(docObj)
              resolve({ status: 200, data: docObj });
            })
            .catch(function (error) {
              //console.log('Error getting mapped attendee:', error)
              reject(error);
            });
        }
      });
    },
    changeTableStatus(tableId, isPublished) {
      // alert(tableId);
      // alert(isPublished);
      let docObj = {
        TableId: tableId,
        IsPublished: isPublished,
      };
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${vm.getSessionToken()}`,
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.getClientId(),
          eventId: vm.getEventId(),
        },
        data: docObj,
      };
      debugger;
      axios
        .put(APIs.RoundTableWriteAPI, requestData, { headers: headers })
        .then(function (res) {
          var success = false;
          if (res.data.status == 0) {
            success = true;
          }
          vm.$refs.roundtableList.onChangeRTStatusSuccess(
            tableId,
            isPublished,
            success
          );
        })
        .catch(function (error) {
          console.log(error);
          vm.$refs.roundtableList.onChangeRTStatusSuccess(
            tableId,
            isPublished,
            false
          );
        });
    },
    deleteTable(tableId) {
      //alert("DELETE: " + tableId);

      let tables = [
        {
          TableId: tableId,
        },
      ];
      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.getClientId(),
          eventId: vm.getEventId(),
        },
        data: {
          tables: tables,
        },
      };
      axios
        .delete(APIs.RoundTableDelete, { data: requestData, headers: headers })
        .then(function (res) {
          //alert(res.data.status)
          var success = false;
          if (res.data.status == 0) {
            success = true;
          }
          vm.$refs.roundtableList.onDeleteTableSuccess(tableId, success);
        })
        .catch(function (error) {
          console.log(error);
          vm.$refs.roundtableList.onDeleteTableSuccess(tableId, false);
        });
    },
  },
};
</script>
<style>
.custom-v-tour .v-step__header {
  background: #19191d !important;
  color: #fff !important;
  position: relative !important;
}
.custom-v-tour .v-step {
  background: #19191d !important;
  color: #dfdfdf !important;
  font-size: 16px !important;
  border: 1px solid #b5b5b5 !important;
  padding: 25px 30px;
}

.custom-v-tour .v-step__header:after {
  content: "";
  position: absolute;
  width: 95%;
  height: 1px;
  background: #2a2a2f;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
}

.custom-v-tour .v-step__button.v-step__button-skip,
.custom-v-tour .v-step__button.v-step__button-previous {
  border: none !important;
  background: #393a3e !important;
  color: #fff !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  border-radius: 2px !important;
  height: 35px !important;
  width: 70px !important;
}

.custom-v-tour .v-step .v-step__arrow {
  border-color: #b5b5b5 !important;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
}
.custom-v-tour .v-step__button.v-step__button-next,
.custom-v-tour .v-step__button.v-step__button-stop {
  border: none !important;
  background: #2376e5 !important;
  color: #fff !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  border-radius: 2px !important;
  height: 35px !important;
  width: 70px !important;
}
</style>